import type { NskResponse } from "~/models/Api";
import { deleteRequest, postRequest } from "~/utils/api/api_handler";

const paths = {
	create: "/vendors/sessions/vendor_users",
	destroy: "/vendors/sessions/vendor_users/:id"
};

export const create = async (
	vendorUserId: number,
	password: string | null
): Promise<NskResponse> =>
	postRequest(paths.create, { password, vendorUserId });

export const destroy = async (): Promise<NskResponse> =>
	deleteRequest(paths.destroy);
